import { API_URL } from "./Config";
import { formatDate } from "./DateUtils";
import { GetSiteVisitDetailsAsync, ISiteVisitDetails } from "./ISiteVisit";
import { ITaskDetails } from "./ITask";
import { GetLicenseDetailsAsync } from "./LicenceDetails";

export interface IFindingAndRecommendation {
  taskid: string;
  datesubmitted: string;
  type: string;
  category: string;
  status: string;
  observation: string;
  reference: string;
}

export interface IFindingAndRecommendationDetails extends ITaskDetails {
  siteVisit?: ISiteVisitDetails;
}

//https://data-int.epa.ie/leap/api/v1/Task/listbyregardingobjectid?regardingobject_id=71DC08F0-BABA-E511-987F-0050568A69E2&page=1&per_page=50

export const GetFindingsAndRecommendationsFetchUrl = (
  regardingObjectId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  let params = `&page=${pageNo}&per_page=${recordsPerPage}`;

  if (searchText.length > 0) {
    params += `&search_term=${encodeURIComponent(searchText)}`;
  }
  let url = `${API_URL}/Task/listbyregardingobjectid?regardingobject_id=${regardingObjectId}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/sitevisit-findings`;
  }

  return url;
};

export async function GetFindingAndRecommendationDetailsAsync(
  taskId: string
): Promise<IFindingAndRecommendationDetails> {
  var url = `${API_URL}/Task/byid?task_id=${taskId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/finding-details`;
  }

  var response = await fetch(url);
  var body = <IFindingAndRecommendationDetails>await response.json();

  const licenceDetails = await GetLicenseDetailsAsync(body.licenceid);
  const siteVisit = await GetSiteVisitDetailsAsync(body.regardingobjectid);

  return <IFindingAndRecommendationDetails>{
    response: response,
    taskid: body.taskid,
    type: body.type,
    licenceid: body.licenceid,
    reference: body.reference,
    status: body.status,
    datesubmitted: formatDate(body.datesubmitted),
    duedate: formatDate(body.duedate),
    subject: body.subject,
    sender: body.sender,
    recipient: body.recipient,
    details: body.details,
    category: body.category,
    subcategory: body.subcategory,
    observation: body.observation,
    description: body.description,
    profileNo: licenceDetails.licenceprofile_number,
    licence_regno: licenceDetails.reg_no,
    siteVisit: siteVisit,
  };
}
